import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';

//import { IMedicalFilePlace} from '../medicalfileplace/medicalfileplace.service';
import { IName } from '../../blocks/names/name.component';
import { IIdentity } from '../../blocks/identity_type/identity_type.component';
import { IAddress } from '../../hospitalSetup/address/address.component';

import { PatientVM, Patient, PatientData, PatCancel } from './patient';
import { CONFIG } from '../../shared/config';
import { Employee } from '../../personnel-setup/employees/employee';


const patientsUrl = CONFIG.baseUrls.patients;
///patent cancel url
const patientCancelUrl = CONFIG.baseUrls.patCancel;


const mdfUrl = CONFIG.baseUrls.MedicalFilePlace;


// employees
let employeesUrl = CONFIG.baseUrls.employees;

@Injectable()
export class PatientService {


    constructor(
        private httpGeneralService: HttpGeneralService) {
    }
    /***********************************************************************
     * used to return prototype from patient object model with init all prop
     */

    getPatientProtoType(): PatientVM {
        const _name = <IName>{};
        const _address = <IAddress>{};
        const _identity = <IIdentity>{};
        return {
            code: 0,
            patCode: 0,
            oldCode: '',
            customCode: '',
            fnameAr: '',
            fnameEn: '',
            snameAr: '',
            snameEn: '',
            tnameAr: '',
            tnameEn: '',
            lnameAr: '',
            lnameEn: '',
            fullnameAr: '',
            fullnameEn: '',
            gender: 0,
            religionId: 0,
            maritalStatus: 0,
            birthDate: null,
            birthPlace: '',
            nationalityId: 0,
            countryCode: 0,
            govCode: 0,
            cityCode: 0,
            villageCode: 0,
            fullAddressAr: '',
            fullAddressEn: '',
            identityType: 0,
            identityValue: null,
            bloodGroup: 0,
            rhValue: 0,
            contractId: 0,
            contractNameAr: '',
            contractNameEn: '',
            parentId: null,
            fatherName: '',
            motherName: '',
            mortalityDate: null,
            fileNo: '',
            stopFlag: 0,
            vipFlag: 0,
            mortaliyFlag: 0,
            mailAddress: '',
            mobile: 0,
            homePhone: 0,
            titleCode: 0,
            employeeId: 0,
            vipLevel: 0,
            nickName: '',
            visitDays: 0,
            heelSampleFlag: 0,
            hepatitisEpidemicSampleFlag: 0,
            familyCount: 0,
            villageNameAr: '',
            villageNameEn: '',
            cityNameAr: '',
            cityNameEn: '',
            countryNameAr: '',
            countryNameEn: '',
            govNameAr: '',
            govNameEn: '',
            nationalityNameEn: '',
            nationalityNameAr: '',
            genderNameAr: '',
            genderNameEn: '',
            religionNameAr: '',
            religionNameEn: '',
            parentEn: '',
            parentAr: '',

            titleNameEn: '',
            titleNameAr: '',

            identityEn: '',
            identityAr: '',

            employeeEn: '',
            employeeAr: '',

            bloodGroupAr: '',
            bloodGroupEn: '',

            maritalStatusEn: '',
            maritalStatusAr: '',

            relativeDegree: 0,
            fastSearchData: '',
            name: _name,
            address: _address,
            identity: _identity,
            dateHijriNgb: null,
            birthDateNgb: null,
            mortalityDateNgb: null,
            therapeuticCards: null,
            visitType: null,
            visitStatus: null,
            companyType: null,
            companyCode: null,
            billNotExtracted: null,
            namingTranslationSettings: null,
            mergedByPatCode: null,
            haveSpecialNeed: null,
            specialNeedType: null,
            specialNeedDesc: '',
            updateStatus: null,
            regIncubationPatMainDataSerial: null,
            comingFrom: null,
            payed: null,
            serviceStatus: null

        };
    }

    getPatients() {
        return this.httpGeneralService.getWith(`${patientsUrl}`);
    }

    getPatient(id: string) {
        return this.httpGeneralService.getWith(`${patientsUrl}/${id}`);
    }

    getCCCallBeneficiarySimilarPat(id: string) {
        return this.httpGeneralService.getWith(`${patientsUrl}/${id}/GetCCCallBeneficiarySimilarPat`);
    }


    searchPatients(searchObj: Patient) {
        return this.httpGeneralService.add(searchObj, `${patientsUrl}/searchSp`);
    }
    searchInPatients(searchObj: Patient) {
        return this.httpGeneralService.add(searchObj, `${patientsUrl}/searchInPatients`);
    }
    searchInPatientsForNphise(searchObj: Patient) {
        return this.httpGeneralService.add(searchObj, `${patientsUrl}/NphiesReg_SearchPatDatacredit`);
    }
    ////////////////fun to getHigridate
    getHigriDate(searchObj: Patient) {
        return this.httpGeneralService.add(searchObj, `${patientsUrl}/getHigridate`);
    }

    ////////////////fun to getGregorianDate from higri
    getGregorianDate(searchObj: Patient) {
        return this.httpGeneralService.add(searchObj, `${patientsUrl}/getGregorianDate`);
    }


    UpdatedduplicatSessionOrStop(patCode: number){  
        return this.httpGeneralService.getWith(`${patientsUrl}/UpdatedduplicatSessionOrStop/${patCode}`);
    }
    addPatient(patient: PatientData) {
        return this.httpGeneralService.add(patient, `${patientsUrl}`);

    }

    modifyPatientsData(patients: Patient[]) {
        return this.httpGeneralService.addCollection(patients, `${patientsUrl}/Patients`);
    }

    /////////////////////////////////////////////////#ibra patient cancel
    cancelPatient(patCancel: PatCancel) {
        return this.httpGeneralService.add(patCancel, `${patientCancelUrl}`);
    }

    updatePatient(PatientData: PatientData) {
        return this.httpGeneralService.update(PatientData.patient.code, PatientData, `${patientsUrl}`);
    }

    deletePatient(patient: Patient) {
        return this.httpGeneralService.delete(patient.code, `${patientsUrl}`);
    }

    addMedicalFilePlace(MFPlace) {
        return this.httpGeneralService.add(MFPlace, `${mdfUrl}`);
    }

    getMedicalFilePlace(serial: number = 0) {
        return this.httpGeneralService.getWith(`${mdfUrl}/${serial}`);
    }

    deleteMedicalFilePlace(serial: number) {
        return this.httpGeneralService.delete(serial, `${mdfUrl}`);
    }


    // new code
    searchEmps(searchObj: Employee) {
        return this.httpGeneralService.search(searchObj, `${employeesUrl}`);
    }

    modifyPatientNameIdentity(patient: Patient) {
        return this.httpGeneralService.add(patient, `${patientsUrl}/ModifyPatientNameIdentity`);

    }
}
